import { createSelector } from 'reselect';
import { I3DSStore } from 'redux/reducers/3dsReducer';

export const get3DSState = (state: { threeDS: I3DSStore; [key: string]: any }) =>
  state.threeDS;

export const get3DSSimulateState = createSelector([get3DSState], state => state.simulate);

export const get3DSSimulateData = createSelector(
  [get3DSSimulateState],
  state => state.data
);

export const get3DSSimulateLoadingError = createSelector(
  [get3DSSimulateState],
  state => state.loadingError
);
export const get3DSSimulateLoadingSuccess = createSelector(
  [get3DSSimulateState],
  state => state.loadingSuccess
);

export const get3DSTimeoutSelector = createSelector(
  [get3DSState],
  state => state.three_ds_timeout
);
